var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPbfPendingRegistration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    rx: 7.5,
    ry: 7,
    fill: "#FF2800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.723 11H9.498L7.373 7.687H5.71V11H4.673V2.662h3.35c1.525 0 2.612.976 2.612 2.513 0 1.5-1.025 2.325-2.162 2.425l2.25 3.4zM7.897 6.775c.987 0 1.662-.663 1.662-1.6 0-.938-.675-1.587-1.662-1.587H5.71v3.187h2.188z",
    fill: "#fff"
  })));
}
export default SvgPbfPendingRegistration;